// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttons {
  margin-top: 0;
}

.outer-inner-wrapper {
  display: grid;
  grid-template-rows: auto 5rem;
}

.canvas-wrapper {
  position: relative;
}

div.container.canvas-wrapper {
  padding-left: 0rem;
  padding-right: 0rem;
}

.toolbar-button {
  border-radius: 50%;
  height: 56px;
  width: 56px;
  display: inline-grid;
  z-index: 1;
}

.delete-button {
  border-radius: 50%;
  height: 3.3rem;
  width: 3.3rem;
  display: block;
  right: 1rem;
  bottom: 2.5rem;
  position: absolute;
  z-index: 1;
}

.delete-button.active {
  transform: scale(1.2) translate3d(0, 0, 0.00001px);
  transition: 100ms ease-in;
  filter: opacity(0.5) drop-shadow(0 0 1px #ff0000);
}

.button-icon {
  height: 48px;
  margin: auto;
  padding: 8px;
}

.delete-button-icon {
  height: 2rem;
  margin: 0.6rem;
}

div.konvajs-content {
  margin: 0rem auto;
  position: relative;
  width: min(100%, 800px);
}

@media (max-width: 599px) {
  .outer-inner-wrapper div.bg-background-3 {
    background-color: inherit;
  }

  .buttons-wrapper {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
  }

  .mobile-toolbar {
    place-self: center;
    padding: 0;
    margin-bottom: -1rem;
  }

  .outer-inner-wrapper .buttons .back-button {
    margin: 1rem 1rem 0 0.5rem;
  }

  .outer-inner-wrapper .buttons .wide {
    margin: 1rem 0.5rem 0 1rem;
    width: auto;
  }

  .delete-button {
    right: 1.5rem;
    bottom: 3.5rem;
  }
}

@media (min-width: 600px) and (max-width: 1199px) {
  footer {
    position: sticky;
    position: -webkit-sticky;
    padding: 1rem 1rem;
    margin-left: auto;
    margin-right: auto;
  }

  .buttons-wrapper {
    display: grid;
    max-width: 750px;
    grid-template-columns: 1fr auto 1fr;
  }

  .mobile-toolbar {
    place-self: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SketchCanvas/Sketch.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;EACd,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kDAAkD;EAClD,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mCAAmC;EACrC;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,mCAAmC;EACrC;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".buttons {\r\n  margin-top: 0;\r\n}\r\n\r\n.outer-inner-wrapper {\r\n  display: grid;\r\n  grid-template-rows: auto 5rem;\r\n}\r\n\r\n.canvas-wrapper {\r\n  position: relative;\r\n}\r\n\r\ndiv.container.canvas-wrapper {\r\n  padding-left: 0rem;\r\n  padding-right: 0rem;\r\n}\r\n\r\n.toolbar-button {\r\n  border-radius: 50%;\r\n  height: 56px;\r\n  width: 56px;\r\n  display: inline-grid;\r\n  z-index: 1;\r\n}\r\n\r\n.delete-button {\r\n  border-radius: 50%;\r\n  height: 3.3rem;\r\n  width: 3.3rem;\r\n  display: block;\r\n  right: 1rem;\r\n  bottom: 2.5rem;\r\n  position: absolute;\r\n  z-index: 1;\r\n}\r\n\r\n.delete-button.active {\r\n  transform: scale(1.2) translate3d(0, 0, 0.00001px);\r\n  transition: 100ms ease-in;\r\n  filter: opacity(0.5) drop-shadow(0 0 1px #ff0000);\r\n}\r\n\r\n.button-icon {\r\n  height: 48px;\r\n  margin: auto;\r\n  padding: 8px;\r\n}\r\n\r\n.delete-button-icon {\r\n  height: 2rem;\r\n  margin: 0.6rem;\r\n}\r\n\r\ndiv.konvajs-content {\r\n  margin: 0rem auto;\r\n  position: relative;\r\n  width: min(100%, 800px);\r\n}\r\n\r\n@media (max-width: 599px) {\r\n  .outer-inner-wrapper div.bg-background-3 {\r\n    background-color: inherit;\r\n  }\r\n\r\n  .buttons-wrapper {\r\n    display: grid;\r\n    grid-template-columns: 1fr auto 1fr;\r\n  }\r\n\r\n  .mobile-toolbar {\r\n    place-self: center;\r\n    padding: 0;\r\n    margin-bottom: -1rem;\r\n  }\r\n\r\n  .outer-inner-wrapper .buttons .back-button {\r\n    margin: 1rem 1rem 0 0.5rem;\r\n  }\r\n\r\n  .outer-inner-wrapper .buttons .wide {\r\n    margin: 1rem 0.5rem 0 1rem;\r\n    width: auto;\r\n  }\r\n\r\n  .delete-button {\r\n    right: 1.5rem;\r\n    bottom: 3.5rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 600px) and (max-width: 1199px) {\r\n  footer {\r\n    position: sticky;\r\n    position: -webkit-sticky;\r\n    padding: 1rem 1rem;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n  }\r\n\r\n  .buttons-wrapper {\r\n    display: grid;\r\n    max-width: 750px;\r\n    grid-template-columns: 1fr auto 1fr;\r\n  }\r\n\r\n  .mobile-toolbar {\r\n    place-self: center;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
